var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScanBorder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 302.376,
    height: 253,
    viewBox: "0 0 302.376 253",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(-2 89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48710",
    "data-name": "Group 48710",
    transform: "translate(-46.5 -310.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29964",
    "data-name": "Group 29964",
    transform: "translate(-10 74)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33857",
    "data-name": "Path 33857",
    d: "M0,0H41.376",
    transform: "translate(60.5 202.5)",
    fill: "#fff",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_826",
    "data-name": "Line 826",
    y2: 41,
    transform: "translate(60.5 202.5)",
    fill: "none",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29965",
    "data-name": "Group 29965",
    transform: "translate(307.5 276.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33857-2",
    "data-name": "Path 33857",
    d: "M41.376,0H0",
    fill: "#fff",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_826-2",
    "data-name": "Line 826",
    y2: 41,
    transform: "translate(41.376)",
    fill: "none",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29966",
    "data-name": "Group 29966",
    transform: "translate(304.5 431.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33857-3",
    "data-name": "Path 33857",
    d: "M41.376,0H0",
    transform: "translate(0 41)",
    fill: "#fff",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_826-3",
    "data-name": "Line 826",
    y1: 41,
    transform: "translate(41.376)",
    fill: "none",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29967",
    "data-name": "Group 29967",
    transform: "translate(50.5 431.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_33857-4",
    "data-name": "Path 33857",
    d: "M0,0H41.376",
    transform: "translate(0 41)",
    fill: "#fff",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_826-4",
    "data-name": "Line 826",
    y1: 41,
    fill: "none",
    stroke: "#fa2c2c",
    strokeLinecap: "round",
    strokeWidth: 4
  }))), /*#__PURE__*/React.createElement("text", {
    id: "_Position_ID_in_the_frame_to_perform_capturing.",
    "data-name": "  Position ID in the frame to perform capturing.",
    transform: "translate(16 -76)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "Poppins-Regular, Poppins"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    xmlSpace: "preserve"
  }, "  Position ID in the frame to perform capturing.")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanBorder);
export default __webpack_public_path__ + "static/media/scan-border.491a40c4.svg";
export { ForwardRef as ReactComponent };